const supportLink =
  "<a href='https://voodoo.atlassian.net/servicedesk/customer/portal/16/group/55/create/198'>Go to support</a>";

const errors: Record<string, { message: string }> = {
  "error.configuration.publish": {
    message: `Something went wrong during the publication process and your configuration wasn't published. You can try again and contact us if the issue continue. ${supportLink}`,
  },
  "error.app.ImportFailure.KitchenAppNotFound": {
    message: `The app corresponding to this unified app id was not found on kitchen. Please recheck it on kitchen and if the issue persist, create a support ticket. ${supportLink}`,
  },
  "error.app.ImportFailure.MissingBundleId": {
    message: `The corresponding kitchen app has no bundle id and can't be used in voodootune.`,
  },
  "error.api.configurationNotFound": {
    message: `Can't find the live configuration for this game, simulation error.`,
  },
  "error.class.InvalidClass.InvalidInstanceValues": {
    message: "There are some errors in your attribute values.",
  },
  "error.configuration.publish.cache": {
    message:
      "The publication is done but the game api couldn't be notified and your config will take a bit more time to propagate. Sorry for the inconvenient.",
  },
  "error.cohorts.allocationRateGreaterThan100": {
    message:
      "This action would attribute a total allocation rate greater than 100 for a priority, please review your allocations rates before trying again.",
  },
  "error.segments.systemSegment": {
    message: "Sorry, you can't delete a default segment",
  },
  "error.configuration.publish.metadata": {
    message: `The publication is done but metadata couldn't be send to the data stack. Please contact us so we can investigate the issue. ${supportLink}`,
  },
  "error.abTest.PriorityAlreadyUsed": {
    message:
      "This publication contains one abtest that conflicts with another abtest with same priority and layer. Please check your ABTests so there are no two published ABs on the same priority and layer",
  },
  "error.configuration.Application.PublicationInProgress": {
    message:
      "A publication is in progress; the configuration is temporarily read-only. Your change was not saved — try again in a moment.",
  },
  defaultApiError: {
    message: `Something went wrong with your request. Please, try again later and contact us if the problem persists. ${supportLink}`,
  },
  defaultLocalError: {
    message: `Something went wrong. Please, try again later and contact us if the problem persists. ${supportLink}`,
  },
};

export default errors;
